module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/project-design-issue-total/project-design-issue-all-grid/project-design-issue-all-grid.component.css
// module id = ./src/app/technical/project-design-issue-total/project-design-issue-all-grid/project-design-issue-all-grid.component.css
// module chunks = main